import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Avatar, Modal, Menu } from "antd";
import { UserMenuWrapper } from "./UserMenu.style";
import { AppContext } from "../../context";
import {
  UserOutlined,
  MailOutlined,
  AppstoreOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { ImExit } from "react-icons/im";
import { logoutUser } from "../../library/user";

const { SubMenu } = Menu;

function UserMenu({ updateList, setUpdateList }) {
  const [key, setKey] = useState(null);
  const info = useContext(AppContext);
  const history = useHistory();

  const handleClick = (e) => {
    setKey(e.key);
    if (e.key === "logout") {
      info.setUser(null);
      logoutUser();
      setUpdateList(!updateList);
    }
    if (e.key === "personal-area") {
      history.push("/reservas");
      info.setUpdateComponent(!info.updateComponent);
    }
    if (e.key === "my-info") {
      history.push("/reservas?seccao=info");
      setUpdateList(!updateList);
    }
  };

  return (
    <>
      <UserMenuWrapper>
        {info.user && (
          <>
            <Menu onClick={handleClick} style={{ width: 156 }} mode="vertical">
              <SubMenu
                key="sub1"
                // icon={<Avatar>{info.user.name[0]}</Avatar>}
                icon={<Avatar icon={<UserOutlined />} />}
                title={
                  info.user?.name
                    ? info.user?.name?.split(" ")[0]
                    : info.user?.email
                }
                // style={{ width: 300 }}
              >
                <Menu.Item key="personal-area" icon={<AppstoreOutlined />}>
                  {info.t("personalArea")}
                </Menu.Item>
                <Menu.Item key="my-info" icon={<AppstoreOutlined />}>
                  {info.t("myInfo")}
                </Menu.Item>
                {/* <Menu.Item key="3" icon={<SettingOutlined />}>
                  Configurações
                </Menu.Item> */}
                <Menu.Item key="logout" icon={<ImExit />}>
                  {info.t("logout")}
                </Menu.Item>
              </SubMenu>
            </Menu>
          </>
        )}
      </UserMenuWrapper>
    </>
  );
}

export default UserMenu;
